import { ReportEventType } from '@/types/report';

export function confidenceToPercentage(confidence: number): number {
    return confidence <= 1 ? confidence * 100 : confidence;
}

export function getReportEventDisplayConfidence(reportEvent: {
    confidence: number | null;
    eventType: ReportEventType;
}): number | undefined {
    if (reportEvent.confidence == null) {
        return undefined;
    }
    const confidencePercentage = confidenceToPercentage(reportEvent.confidence);
    if (
        reportEvent.eventType === ReportEventType.TRACKED_OBJECT &&
        confidencePercentage === 100
    ) {
        return undefined;
    }
    return confidencePercentage;
}
